import { render, staticRenderFns } from "./HorizontalScrollerItems.vue?vue&type=template&id=37411f78&scoped=true&"
import script from "./HorizontalScrollerItems.vue?vue&type=script&lang=js&"
export * from "./HorizontalScrollerItems.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalScrollerItems.vue?vue&type=style&index=0&id=37411f78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37411f78",
  null
  
)

export default component.exports